exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{font-family:Karla,sans-serif;font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./client/redesign/css/index.css
// module id = 326
// module chunks = 0